<template>
  <div>
    <div class="wrapper wrapper-full-page"  ref="wizard">
      <div class="full-page home-page" data-color="red"
           data-image="static/img/background/home-background.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
<div class="col-md-12">
  <div class="header-text header-section">
    <img  width="320" height="auto" class="img-fluid" alt="PPE Matcher" src="static/img/ppes-seiu121rn-logo.jpg"></div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard shape="tab"
                       @on-complete="wizardComplete"
                       @on-change="tabChanged"
                       error-color="#E60A0A"
                       color="#77b300"
                       title="Report Insufficient PPE"
                       subtitle="">
            <tab-content title="I NEED PPE"
                         :before-change="validateFirstStep"
                         icon="ti-user">
              <first-step ref="firstStep"></first-step>
            </tab-content>
            <tab-content title="SEND"
                         icon="ti-check">
    <div class="row">
    <div class="col-md-10 col-md-offset-1">
<h3 class="text-center text-space seiu"><b>Thank You for Standing Up for A Safe Workplace. <br />Please click FINISH and keep reporting using this app.</b>
</h3>
    </div>
    <div class="col-md-1">
    </div>
    </div>

              
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
              <h3>Your info:</h3>
              <p>
              <strong>Name: </strong> {{ my1stModel.firstName }} {{ my1stModel.lastName }}<br />
              <strong>Personal email:</strong> {{ my1stModel.email }} <br />
              <strong>Department:</strong> {{ my1stModel.facilityDepartment}} <br />
              <strong>Job Title:</strong> {{ my1stModel.jobTitle }} <br />
              <strong>Working without PPEs?</strong> {{ my1stModel.workingWithoutPpes ? 'yes' : 'no'}}
              </p>
              <p></p>
      </div>
      <div class="col-md-5">
 <h3 class="seiu">This is what you are reporting as missing in your workplace:</h3>
              <p>
              {{ getPpes(my1stModel) }}<br />
              </p>
              <h3>Facility Name:</h3>
              <strong>{{ my1stModel.facility }} {{ my1stModel.facility === 'Other' ? ': ' + my1stModel.otherFacility : ''}} </strong><br />
             <h3>Your Mobile Phone:</h3>
              <div class="form-group">
                <input class="form-control member-phone"
                      type="text"
                      name="memberPhone"
                      v-model="memberPhone"
                      placeholder="ex: 8181234567"
                      maxlength="10"
                      minlength="10"
                />
        </div>
      </div>
      <div class="col-md-1"></div>
      <div class="row">
        <div class="col-md-8 col-md-offset-2">                  
              <p style="margin-top: 30px;">
* By providing my mobile phone number, I understand that SEIU and its locals and affiliates may use automated calling technologies and/or text message me on my mobile phone on a periodic basis. SEIU will never charge for text message alerts. Carrier message and data rates may apply to such alerts. Text STOP to 787753 to stop receiving messages. Text HELP to 787753 for more information.
        </p>
              <p></p>
              <h3 class="text-center text-space seiu">{{ this.message }} </h3>
              <h3 v-if="this.subMessage" class="text-center">Click on "<b>Finish</b>" to submit your entry!</h3>
              <h3 class="text-center text-space" v-if="goHome"><a href='/'>Start New Request</a></h3>
                <br>
        </div>
        <div class="col-md-2"></div>
      </div>

    </div> <!-- info row -->
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Back</button>
            <button slot="next" class="btn btn-info btn-fill btn-wd btn-next">Next</button>
            <button slot="finish" class="btn btn-info btn-fill btn-wd ">Finish</button>
          </form-wizard>
        </div>
      </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              Copyright &copy; 2020 Interdisciplinary Humanistic Technologies All rights reserved.
            </div>
          </div>
        </footer>
        <div class="full-page-background" style="background-image: url(static/img/background/home-background.jpg) "></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Register</a>
        </router-link>
        <router-link to="/admin/overview" tag="li">
          <a>Map</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'

  import FirstStep from './Wizard/FirstStep.vue'
  import swal from 'sweetalert2'

  export default {
    data () {
      return {
        memberPhone: '',
        wizardModel: {},
        my1stModel: {},
        my2ndModel: {},
        ppeNeed: {},
        finished: false,
        subMessage: true,
        message: 'I’m Taking a Stand for Safety as a member of SEIU121RN.',
        goHome: false,
        axios_config: {
          headers: {
            'Content-Type': 'application/json',
            Authorization: '',
            'app_user_id': 'seiu_user',
            'app_user_name': 'Seiu User'
          }
        }
      }
    },
    components: {
      FormWizard,
      TabContent,
      FirstStep
    },
    methods: {
      getPpes (provider) {
        let tmpPpes = []
        let ppes = ''

        if (provider.bonnetsQty > 0) {
          tmpPpes.push('Bonnets')
        }
        if (provider.bootiesQty > 0) {
          tmpPpes.push('Booties')
        }
        if (provider.glovesQty > 0) {
          tmpPpes.push('Gloves')
        }
        if (provider.gownsQty > 0) {
          tmpPpes.push('Gowns')
        }
        if (provider.hazmatSuitsQty > 0) {
          tmpPpes.push('HazmatSuits')
        }
        if (provider.n95MasksQty > 0) {
          tmpPpes.push('N95 Masks')
        }
        if (provider.respiratorHoodsQty > 0) {
          tmpPpes.push('PAPR Respirator Hoods')
        }
        if (provider.splashGuardsQty > 0) {
          tmpPpes.push('Splash Guards')
        }
        if (provider.eyeProtectionQty > 0) {
          tmpPpes.push('Eye Protection')
        }

        if (provider.needsDonDoffHelp) {
          tmpPpes.push('Don/Doff Help')
        }
        console.log(tmpPpes.toString)
        var ppesString = tmpPpes.toString()
        console.log(ppesString)
        ppes = ppesString.replace(/,/g, ', ')
        return ppes
      },
      tabChanged (oldIndex, newIndex) {
        window.scrollTo(0, 0)
       // alert(localStorage.getItem('facilityLatitude'))
       // alert('tab changed!')
       // console.log(this.$refs.firstStep.model)
        switch (newIndex) {
          case 0:
            // this.$refs.name.focus()
            break
          case 1:
            break
          case 2:
            // this.$refs.interests.focus()
            break
        }
      },
      validateFirstStep () {
        // this.$refs.secondStep.$refs.first.focus()
        // this.$refs.secondStep.first.focus()
        // this.$refs.wizard.focus()
        console.log('the date is', this.$refs.firstStep.model.incidentDate)
        return this.$refs.firstStep.validate()
      },
      validateSecondStep () {

      },
      wizardComplete () {
        // we gather models from all steps into one model
        this.wizardModel = {
          ...this.$refs.firstStep.model
        }
        console.log('the wizard data is:')
        console.log(this.wizardModel)
        this.wizardModel.department = 'Emergency Room 831'
        this.wizardModel.title = 'Registered Nurse 81'
        this.wizardModel.location = '100,125'
        // let ppeRequest = {
        //   'Item': this.wizardModel
        // }
        // const incidentDate = Date.parse(this.wizardModel.incidentDate)
        this.ppeNeed = {
          'bonnetsQty': parseInt(this.wizardModel.bonnetsQty, 10),
          'bootiesQty': parseInt(this.wizardModel.bootiesQty, 10),
          'gownsQty': parseInt(this.wizardModel.gownsQty, 10),
          'n95MasksQty': parseInt(this.wizardModel.n95MasksQty, 10),
          'respiratorHoodsQty': parseInt(this.wizardModel.respiratorHoodsQty, 10),
          'splashGuardsQty': parseInt(this.wizardModel.splashGuardsQty, 10),
          'glovesQty': parseInt(this.wizardModel.glovesQty, 10),
          'hazmatSuitsQty': parseInt(this.wizardModel.hazmatSuitsQty, 10),
          'eyeProtectionQty': parseInt(this.wizardModel.eyeProtectionQty, 10),
          'donDoffHelpNeed': this.wizardModel.needsDonDoffHelp,
          'email': this.wizardModel.email,
          'memberPhone': this.memberPhone,
          'firstName': this.wizardModel.firstName,
          'lastName': this.wizardModel.lastName,
          'facilityName': this.wizardModel.facility,
          'facilityDepartment': this.wizardModel.facilityDepartment,
          'jobTitle': this.wizardModel.jobTitle,
          'otherJobTitle': this.wizardModel.otherJobTitle,
          'otherFacility': this.wizardModel.otherFacility,
          'workingWithoutPPEs': this.wizardModel.workingWithoutPpes,
          'incidentDate': this.wizardModel.incidentDate,
          'comments': this.wizardModel.comments
        }
        let ppeRequest = {
          'Item': this.ppeNeed
        }

        if (!this.finished) {
          this.finished = true
          axios.post('https://gdgpm0vbn5.execute-api.us-west-2.amazonaws.com/prod/ppe-request', ppeRequest, this.axios_config)
          .then((response) => {
            console.log('PPE requests saved successfully')
            // this.loading = false
            swal({
              title: `Success!`,
              text: 'Thank you!',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'success'
            })
            this.$router.replace(this.$route.query.redirect || '/thank-you')
            // this.$router.replace(this.$route.query.redirect || '/admin/profile')
          })
          .catch(function (error) {
            console.log(error)
            // this.loading = false
          })
        }


        // this.subMessage = false
        // this.message = 'Thank you, request submitted!'
        // this.goHome = true
        // swal('Thank you!', 'Your request has been submitted!', 'success')
      }
    },
    mounted () {
      this.my1stModel.facility = {}
      this.my1stModel = this.$refs.firstStep.model
    }
  }
</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9A9A9A !important;
    color: white;
  }
  .vue-form-wizard .wizard-title {
    margin-top:15px;
    margin-bottom:15px;
  }
  .vue-form-wizard .wizard-icon-circle.tab_shape {
	background-color: #999999 !important;
	color: white;
}
.card-wizard {
	border-radius: 0 0 6px 6px !important;
}


.header-section {
  background-color: white;
  margin-top: 25px;
	margin-left: -15px;
  margin-right: -15px;
  text-align: center;
  border-radius: 6px 6px 0 0;
    }
.header-section img {
  padding-top: 20px;
}

.navbar .navbar-nav > li > a.btn.btn-info.btn-fill, .btn-info.btn-fill {
	color: #FFFFFF;
  background-color: #ff8800;
  border-color: #ff8800;
	opacity: 1;
  filter: alpha(opacity=100);
  text-transform: uppercase;
    border-radius: 6px;
font-size: 18px;
font-weight: 400;
padding: 14px 30px;
}
.navbar .navbar-nav > li > a.btn.btn-info.btn-fill, .btn-info.btn-fill:active {
	color: #FFFFFF;
  background-color: #ff8800;
  border-color: #ff8800;
	opacity: 1;
  filter: alpha(opacity=100);
  text-transform: uppercase;
}
.btn-back {
  background-color:#9A9A9A !important;
  border-color:#9A9A9A !important;
  border-radius: 6px !important;
font-size: 18px !important;
font-weight: 400 !important;
padding: 14px 30px !important;
text-transform: uppercase;
}

.btn-back:hover, .btn-back:focus{
  background-color:#9A9A9A !important;
  border-color: #9A9A9A !important;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 400;
  padding: 14px 30px;
}

.btn-next {
  background-color:#ff8800 !important;
  border-color:#ff8800 !important;
  border-radius: 6px;
font-size: 18px;
font-weight: 400;
padding: 14px 30px;
}

.btn-next:active {
  background-color:#ff8800 !important;
  border-color:#ff8800 !important;
  border-radius: 6px;
font-size: 18px;
font-weight: 400;
padding: 14px 30px;
}
.btn-info.btn-fill:hover {
  background-color:#8bf513 !important;
  border-color: #8bf513 !important;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 400;
  padding: 14px 30px;
}

  .btn-info.btn-fill:focus{
  background-color:#ff8800 !important;
  border-color: #ff8800 !important;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 400;
  padding: 14px 30px;
}

#needs label {
	display: inline-block;
	width: 100%;
	margin-bottom: 5px;
	font-weight: 700;
}

#needs .btn-group {
  width: 100%;
}

.seiu {
 	color: #662fbc;
}

.card {
  color: rgb(41, 40, 40) !important;
}

.member-phone{
  background-color: #FFFF00 !important;
  color: black !important;
  border: 1px solid #662fbc !important;
}

.member-phone:focus{
  background-color: #FFFF00 !important;
  color: black !important;
  border: 1px solid #662fbc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Home.vue